// extracted by mini-css-extract-plugin
module.exports = {"container":"create-contact-group_container__1lx88","returnButton":"create-contact-group_returnButton__kC9r0","form":"create-contact-group_form__NdYde"};